export const CoreTheme = {
    primaryColor: '#247bd9',
    accentColor: '#4a8fd9',

    secondaryColor: 'rgba(9, 30, 66, 0.04)',
    secondaryAccentColor: 'rgba(9, 30, 66, 0.08)',

    primaryFont: 'Montserrat',
    primaryColorText: '#00121f',
    secondaryColorText: '#717171',

    fontSizeXSmall: '8px',
    fontSizeSmall: '10px',
    fontSizeMedium: '12px',
    fontSizeMediumLarge: '14px',
    fontSizeLarge: '16px',
    fontSizeXLarge: '18px',
    fontSizeXXLarge: '22px',
    fontSizeXXXLarge: '24px',

    urlLogin: 'url("assets/5.png")',
    urlLogo: 'url("assets/logo-ops.jpg")',
    loginHeightLogo: '66px',
    loginWidthLogo: '160px',
    headerTextColor: '#fff',
    headerWidthLogo: '150px',

    error: '#d63342',
    success: '#8db602',
    warning: '#f8b903',
    info: '#a0a0a0',

    extraLightGrease: '#fcfcfc',
    veryLightGrease: '#efefef',
    grease: 'rgb(223, 225, 230)',
    baseBorderRadius: '2px',
    white: '#fff',
    accentPrimaryGrease: 'rgb(244, 245, 247)'

}